import { FC, useContext, useEffect, useState } from "react";
import { InfoBox } from "../../Elements/Alert/InfoBox";
import { useTranslation } from "react-i18next";
import { Section } from "../../Components/Section";
import { SubSection } from "../../Components/SubSection";
import { Radio, Button } from "@inceptionbg/ui-components";
import { ConsentType, ConsentTypes } from "../../types/IConsent";
import { FarmContext } from "../../AppContent";
import { updateFarm } from "../../repos/FarmRepo";
import { useNavigate } from "react-router-dom";

const ConsentManagementPage: FC = () => {
  const { t } = useTranslation();
  const [value, setValue] = useState<ConsentType | undefined>();
  const navigate = useNavigate();

  const { farm } = useContext(FarmContext);

  useEffect(() => {
    setValue(farm?.dataConsentType);
  }, [farm?.dataConsentType]);

  return (
    <Section id="basic" title={t("ConsentManagementSection")}>
      <InfoBox
        title={t("ConsentManagementPageTitle")}
        desc={t("ConsentManagementPageDesc")}
        className="ml-4 mr-4 mb-4 mt-0"
        light
      />
      <SubSection className="pt-0">
        <div>
          <b>{t("LegalEntities")}</b>
          <div className="my-4">
            {ConsentTypes.map((type) => (
              <div key={type} className="mb-2">
                <Radio
                  label={t("Consent" + type)}
                  value={type}
                  selected={value || ""}
                  setSelected={(dataConsentType) =>
                    farm?.uuid &&
                    updateFarm(farm.uuid, { dataConsentType }).then(() =>
                      setValue(dataConsentType)
                    )
                  }
                />
                {type === "SELECTED" && value === "SELECTED" && (
                  <div className="mt-1 ml-5">
                    <Button
                      label={t("ConsentUserListButton")}
                      onClick={() => navigate("/consent-management/individual")}
                      size="s"
                      primary
                    />
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
        <div style={{ borderTop: "2px solid var(--primary)" }} />
        <div className="mt-3">
          <b>{t("BudgetUsers")}</b>
          <div className="my-4">
            <div className="mb-2">
              <Radio
                className="disabled-text"
                label={t("ConsentNONE")}
                value={""}
                setSelected={() => {}}
                selected={"NONE"}
                disabled={true}
              />
            </div>
            <div className="mb-2">
              <Radio
                label={t("ConsentALL")}
                value={true}
                setSelected={() => {}}
                selected={true}
              />
            </div>
            <div className="mb-2">
              <Radio
                className="disabled-text"
                label={t("ConsentSELECTEDC")}
                value={""}
                setSelected={() => {}}
                selected={"SELECTED"}
                disabled={true}
              />
            </div>
          </div>
        </div>
      </SubSection>
    </Section>
  );
};

export default ConsentManagementPage;
